import { makeStyles } from '@material-ui/core/styles';

export const useAddEditClaimsTaskStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    overflowY: 'auto',
  },
}));
